import apiRequest from '@/services/apiRequest';
import { getCoreApi } from '@/utility/getCoreApi';

export interface IGroupBookingEnquiryPayload {
  first_name: string;
  last_name: string;
  phone_number: string;
  email: string;
  event_start_date: string;
  event_end_date: string;
  number_of_rvs: number;
  location: string;
  event_type: string;
  full_hookups: string;
  primary_rv_use: string;
  rental_cars: string;
  group_size_range: string;
  approximate_budget_range: string;
}

const GROUP_BOOKINGS_QUESTIONS_URL = `${getCoreApi()}/bookings/group-bookings-questions`;

export const submitGroupBookingEnquiry = async (data: IGroupBookingEnquiryPayload) => {
  return apiRequest(
    {
      url: GROUP_BOOKINGS_QUESTIONS_URL,
      method: 'POST',
      data,
    },
    true,
    true,
  );
};
